import dynamic from 'next/dynamic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import BannerModule from '@/components/ProductDetailComponents/BannerModule';

const webpUrl = '/media/delta/pc/';

const PageConPc = dynamic(() => import('@/components/ProductDelta/deltanew/indexDynamic'), {
    ssr: true,
});
export default function Delta({ cssStyle }: any) {
    const defaultStyle = {
        background: 'transparent',
        padding: '0',
        margin: '0 auto',
        border: 'none',
        borderRadius: '0',
    };
    const { useLang } = useGlobal();
    const { t } = useLang('delta_new');

    const bannerData = [
        {
            bgImgs: ['1_main.webp', '1_main.jpg'],
            title: t('DELTA'),
            des: t('banner'),
        },
    ];

    const styles = { ...defaultStyle, ...cssStyle };

    return (
        <div
            className={`${css.delta} DeltaModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <div style={{ width: '100%', marginTop: '-64px' }}>
                <BannerModule data={bannerData} config={{ position: 'top', titleColor: '#fff', desColor: '#fff', isWebp: true, webpUrl }} theme={'black'} />
            </div>
            <PageConPc />
        </div>
    );
}
